<template>
  <div class="goods-header">
        <div class="contents contents-box">
            <div class="contents-left">
                <div class="contents-left-left">
                    <div class="contents-left-left-img">
                        <router-link :to="{ name: 'brand', params: { id: bannerId }}"><img :src="bannerImg"></router-link>                        
                    </div>
                     <!-- <div class="contents-left-left-lable">
                        <i class="icon iconfont icon-ditu area-ditu"></i>
                        <span>{{area}}</span>
                    </div> -->
                </div>
                <div class="contents-left-right">

                    <div class="contents-left-left-lable">
                        <i class="icon iconfont icon-ditu area-ditu"></i>
                        <span>分公司及办事处<!--{{area}} --></span>
                    </div>
                    <ul class="contents-left-right-list">
                        <li class="contents-list-item" v-for="(item,index) in brandInfoAll" :key="index" @click="show(index)">{{item.name}}</li>
                        <!-- <li class="contents-list-item" @click="show()">江苏吴江</li>
                        <li class="contents-list-item" @click="show()">江苏昆山</li>
                        <li class="contents-list-item" @click="show()">深圳</li>
                        <li class="contents-list-item" @click="show()">成都</li> -->
                    </ul>                   
                </div>
            </div>

            <div class="contents-right">
                <div class="contents-right-item contents-right-item-fenxiang" @click="handleCompareChange">
                    <img src="/static/icon/duibi.svg" alt="" style="width: 28px; height: 28px;padding-top: 2px;">
                    <p>
                        对比
                    </p>
                </div>
                <div class="contents-right-item contents-right-item-shoucang" @click="toshoucang()">
                    <i v-if="goodsInfo.store==1" class="icon iconfont icon-shoucang2"></i>
                    <i v-else class="icon iconfont icon-shoucang"></i>
                    
                    <p>
                        收藏
                    </p>
                </div>
            </div>
        </div>

        <div v-if="showpage" class="showpage" @click="close()">
            <div class="showpageinfo" @click.stop>
                <div class="showpageinfo-header">
                    <img :src="bannerImg" />
                    <i class="icon iconfont icon-quxiao" @click="close()"></i>                    
                </div>
                <div class="contents-left-left-lable contents-left-left-lable-show">
                    <i class="icon iconfont icon-ditu area-ditu"></i>
                    <span>{{showInfo.langname}}</span>
                </div>
                <div class="showpageinfo-footer">
                    <p class="title-address">
                        <span class="title">
                            公司名称：
                        </span>
                        <span class="title-info">
                            {{showInfo.corporateName}}
                        </span>
                    </p>
                    <p >
                        <span class="title">公司地址：</span>
                        <span class="title-info">{{showInfo.address}}</span>
                    </p>
                </div>    
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    data(){ 
        return {
            showpage:false,
            brandInfoAll:[],
            showInfo:{},
        }  
    },
    props: ['area','bannerImg','className',"goodsInfo","bannerId"],
    computed: {
        ...mapGetters(["compareList"]),
        isCompared() {
            if (!this.goodsInfo || !this.goodsInfo.id) return false;
            // 用 String 比较，避免不同接口返回的 id 类型不一致（数字/字符串）导致已添加判断失效
            return this.compareList.some(item => String(item.id) === String(this.goodsInfo.id));
        }
    },
    methods:{
        handleCompareChange(){
            console.log(this.goodsInfo.class_info.pid,'goodsInfo');
            if (!this.goodsInfo || !this.goodsInfo.id) return;
            if (this.isCompared) {
                this.$store.commit("removeCompareGoods", this.goodsInfo.id);
                this.$root.$emit('show-compare-panel');
                return;
            } else {
                if (this.compareList.length >= 4) {
                    this.$message.warning("最多添加4个产品进行对比！");
                    this.$root.$emit('show-compare-panel');
                    return;
                }
                // 类型不一致，只能添加同类型方案进行对比！
                if (this.goodsInfo.class_info.pid && this.compareList.length > 0 &&
                    this.compareList.some(item => item.idx_cid1 && item.idx_cid1 != this.goodsInfo.class_info.pid)) {
                    this.$message.warning("类型不一致，只能添加同类型产品进行对比！");
                    // 类型不一致时展开对比侧边栏，方便用户查看已添加的产品
                    this.$root.$emit('show-compare-panel');
                    return;
                }
                console.log(this.goodsInfo);
                const goods = {
                    id: this.goodsInfo.id,
                    idx_cid1: this.goodsInfo.class_info.pid,
                    name: this.goodsInfo.title || this.goodsInfo.name,
                    pic: this.goodsInfo.avatar || this.goodsInfo.pic || this.goodsInfo.image,
                    price: this.goodsInfo.price,
                    parameterStr: (this.goodsInfo.productMiddle || [])
                        .filter(m => m.info)
                        .map(m => m.info) //m.title + '：' + m.info
                        .join(' '),
                };
                this.$store.commit("addCompareGoods", goods);
                // 当前页面主动添加成功后，展开对比侧边栏
                this.$root.$emit('show-compare-panel');
            }
        },
        toshoucang(){
            this.$emit('toshoucang');
        },
        close(){
            this.showpage = false
        },
        show(val){
            this.showInfo = this.brandInfoAll[val]
            this.showpage = true
        },
        getBrandInfoAll(bannerId) {
            var res = this.$api.brand.getBrandInfo(bannerId);
            this.brandInfoAll = res.subsidiary;
        },
    },
}
</script>

<style  scoped>
    .title-address{
        margin-bottom: 21px;
    }
    .showpage{
        position: fixed;
        left: 0;
        right: 0;
        top:0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 200;
    }
    .showpageinfo{
        position:absolute;
        left:calc(50% - 175px);
        top:calc(50% - 75px);
        width: 350px;
        height: 150px;
        padding:17px 32px;
        background:url(/static/goods/bj.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        z-index: 201;
        flex-direction: column;
        justify-content: space-between;

    }
    .showpageinfo-header{
        overflow: hidden;
    }
    .showpageinfo-header img{
        width: 83px;
        float: left;
    }
    .showpageinfo-header .icon-quxiao{
        float: right;
        cursor:pointer;
    }
    .showpageinfo .contents-left-left-lable-show{
        margin-left: 0;
        font-size: 18px;
        color:#333;
    }
    .contents-left-left-lable-show .icon{
        font-size: 18px;
    }
    .showpageinfo-footer{
        font-size: 12px;
        color: #333333;
        overflow: hidden;
    }
    .showpageinfo-footer .title{
        color: #666666;
        display: inline-block;
        width: 60px;
        float: left;
    }
     .showpageinfo-footer .title-info{
         display: inline-block;
        width: 290px;
        float: left;
    }




    .goods-header{
        width: 100%;
        min-height: 50px;
        margin-top:25px;
    }
    .contents-box{
        background-color: #fff;
        min-height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-radius: 10px;
    }
    .contents-left{
        margin-left: 47px;
        display: flex;
        align-items: center;
    }
    .contents-left-left-img{
        width: 90px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 5px;
        margin-right: 5px;
        box-shadow: 3px 3px 8px rgb(72 72 72 / 20%);
    }
    .contents-left-left-img img{
        max-width: 100%;
        max-height: 60px;
    }
    .area-ditu{
        color: #fbb113;
        font-size: 20px;
    }
    .contents-left-left-lable{
        display: flex;
        align-items: center;
        color: #666666;
        font-size: 14px;
        margin-left: 19px;
    }
    /* .contents-left-right{
        font-size: 24px;
        color: #232323;
        margin-left: 60px;
    } */
    .contents-left-right .contents-left-right-list{
        font-size: 14px;
        color: #333333;
        margin-left: 22px;
        overflow: hidden;
        margin-top: 3px; 
        cursor:pointer;       
    }
    .contents-left-right .contents-left-right-list li:hover{
        color:#2655ae;
    }
    .contents-list-item{
        float: left;
        margin-right: 15px;
    }
    .contents-right{
        margin-right: 47px;
        display: flex;
    }
    .contents-right-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 30px;
        cursor:pointer;        
    }
    .contents-right-item i{
        font-size: 30px;
        color: #2655ae;
        font-weight: 600;
    }
    .contents-right-item p{
        font-size: 14px;
    }


    /* .contents-left-right-list{
        333333
    } */
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsInfo.vue